import styled from 'styled-components';
import { forTablet } from '@westwing/ui-kit/breakPoints';
import Text from '@ids/components/Typography/Text';
import AspectRatio from '@ids/components/Layout/AspectRatio';

export const NUMBERS_TOP_INSET = '25px';

export const Steps = styled.div`
    position: relative;
    display: grid;
    gap: calc(40px + ${NUMBERS_TOP_INSET}) 20px;
    margin: calc(40px + ${NUMBERS_TOP_INSET}) 24px 40px;

    ${forTablet`
        grid-template-columns: repeat(3, 1fr);
    `}
`;

export const Line = styled.svg`
    position: absolute;
    z-index: 1;
    width: 100%;
    height: calc(100% + 45px);
    top: -25px;

    ${forTablet`
        display: none;
    `}
`;

export const Step = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;

    &:before {
        z-index: 3;
        position: absolute;
        top: -${NUMBERS_TOP_INSET};
        left: 0;
        content: '';
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: ${({ theme }) => theme.colors.charcoal100};
    }

    &:after {
        z-index: 3;
        position: absolute;
        top: -${NUMBERS_TOP_INSET};
        left: 20px;
        content: attr(data-step);
        font-size: 80px;
        font-family: chron-icle-roman, 'Times New Roman', serif;
        color: ${({ theme }) => theme.colors.charcoal100};
        line-height: 62px;
    }

    ${forTablet`
        &:before {
            content: none;
        }
        &:after {
            left: 12px;
        }
    `}
`;

export const MediaWrapper = styled(AspectRatio)`
    position: relative;
    background: ${({ theme }) => theme.colors.charcoal3};
    border: 1px solid ${({ theme }) => theme.colors.skeleton01};
    width: 100%;
    margin: 0 -4px 20px;
    z-index: 2;
`;

export const TextWrapper = styled.div`
    margin: 0 0 10px 30px;

    ${forTablet`
        margin: initial;
    `}
`;

export const Title = styled(Text).attrs({ variant: 'subtitle', as: 'h3' })`
    margin-bottom: 10px;
`;

export const ContentText = styled(Text).attrs({ variant: 'paragraph' })``;
